import map from '@/utils/map'
import objToCss from '@/utils/obj-to-css'
import googleFontUrl from '@/utils/googleFontUrl'

export default {
  ampCssAndFonts: state => {
    const fontContainer = {}
    const css = []

    Object.entries(map.css).forEach(([ category, selector ]) => {
      css.push(objToCss(selector, state.amptheme[category], fontContainer))
    })

    return {
      css: css.join(''),
      fonts: googleFontUrl(state.amptheme, fontContainer)
    }
  },
  logoHeight: state => {
    if (state.amptheme.logo.height) {
      return Number(state.amptheme.logo.height.replace('px', ''))
    }

    return 0
  }
}
